import { cleanMVPD } from 'helpers/mvpdStorage';
import { removeCookie } from 'helpers/VanillaCookie';

export default function (onSuccess) {
    // trigger Adobe Enabler logout
    if (window.hasOwnProperty('ae') && window.ae.hasOwnProperty('logout')) {
        window.ae.logout();
    }

    $.ajax({
        url: '/account/logout/',
        type: 'GET',
        dataType: 'json',
        error: function () {
            alert('Error occurred, please try again later');
        },
        success: function (resp) {
            if (resp.success === true) {
                // prevent abandon popup after user signs out
                removeCookie('aa-abandon-ovl', {
                    path: '/',
                });

                cleanMVPD();
                if (typeof onSuccess === 'function') {
                    onSuccess();
                } else {
                    let path = (function (pathname) {
                        return pathname.substr(-1) === '/' ? pathname : pathname + '/';
                    })(window.location.pathname);

                    window.location.href = '/';
                }
            }
        },
    });
}
